import React, { FC, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import withStyles from '@mui/styles/withStyles'

import { Context } from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesContext'
import AcquiringChargesTableRow from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTableRow'
import { useStyles } from 'components/core/Acquiring/AcquiringCharges/components/styles'
import { finishErrorAlert } from 'redux/alert/alert-actions'
import { useAppSelector } from 'redux/hooks'
import { themeStyles } from 'themes'
import combineStyles from 'utils/combineStyles'

const SettlementsTable: FC = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { errorAlert } = useAppSelector(state => state.alert)
    const { loader, charges } = useContext(Context)

    const style = useStyles()

    useEffect(() => {
        if (errorAlert) {
            dispatch(finishErrorAlert())
        }
    }, [charges])

    return (
        <Grid container spacing={3}>
            <Grid item md={12} lg={12} className="verticalScrollable">
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table" className={style.tableContainer}>
                        <TableHead>
                            <TableRow>
                                <TableCell align="left" padding="normal">
                                    {t('Acquiring.InitiatedOn')}
                                </TableCell>
                                <TableCell align="left">{t('Acquiring.Status')}</TableCell>
                                <TableCell align="left" padding="normal">
                                    {t('Acquiring.Amount')}
                                </TableCell>
                                <TableCell align="right" padding="normal">
                                    {t('Acquiring.ExternalID')}
                                </TableCell>
                                <TableCell align="right" padding="normal">
                                    {t('Acquiring.Details')}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loader?.GET_CARD_ACQUIRING_CHARGES ? (
                                <TableRow>
                                    <TableCell>{t('Acquiring.LoadingCharges')}</TableCell>
                                </TableRow>
                            ) : !charges?.records?.length ? (
                                <TableRow>
                                    <TableCell>{t('Acquiring.NoResults')}</TableCell>
                                </TableRow>
                            ) : (
                                charges &&
                                charges?.records?.map((charge: ChargesRecord, i: any) => (
                                    <AcquiringChargesTableRow key={i} charge={charge} />
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    )
}

export default withStyles(combineStyles(themeStyles.useAcquiringStyles, themeStyles.useTableStyles))(SettlementsTable)
